module.exports = __webpack_public_path__ + "static/media/04PerformancePhotos.76b956ac.jpeg";